export enum activeNavigation {
    COMPANY = 'COMPANY',
    ALL_PROJECTS = 'ALL_PROJECTS',
    MY_PROJECTS = 'MY_PROJECTS',
}
